import createReducer from 'reducers/createReducer';

import { ShopDrivingRangeOptionSetting } from 'actions/actionTypes';

const INITIAL_STATE = { 
    data: {
        courseId: 'D001',
        difficulty: 4,
        teeHeight: 45,
        windSpeed: 0,
        distanceUnit: 0,
        useSwingPlate: 0,
        isBallTrajectory: true,
        isFixedCamera: false,
        isSwingVideo: true
    },
    error: {
        triggered: false,
        message: ''
    },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
    [ShopDrivingRangeOptionSetting.CHANGE_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO]: (state, action) => {
        state.data[action.payload.name] = action.payload.value;
    },

    [ShopDrivingRangeOptionSetting.LOAD_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [ShopDrivingRangeOptionSetting.LOAD_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST_SUCCESS]: (state, action) => {
        state.data.courseId = action.payload.courseId;
        state.data.difficulty = action.payload.difficulty;
        state.data.teeHeight = action.payload.teeHeight;
        state.data.windSpeed = action.payload.windSpeed;
        state.data.distanceUnit = action.payload.distanceUnit;
        state.data.useSwingPlate = action.payload.useSwingPlate;
        state.data.isBallTrajectory = action.payload.isBallTrajectory;
        state.data.isFixedCamera = action.payload.isFixedCamera;
        state.data.isSwingVideo = action.payload.isSwingVideo;
    },
    [ShopDrivingRangeOptionSetting.LOAD_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload
        };
    },

    [ShopDrivingRangeOptionSetting.EDIT_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [ShopDrivingRangeOptionSetting.EDIT_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST_SUCCESS]: (state, action) => {
    },
    [ShopDrivingRangeOptionSetting.EDIT_SHOP_DRIVING_RANGE_OPTION_SETTING_INFO_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload
        };
    },
});


export default reducer;